import React from "react";
import { Grid, Typography, Box, Button } from "@mui/material";
import { useTranslation } from "react-i18next";

/**
 * Contact component
 * It renders the entire Contact page component
 * 
 * @returns {JSX.Element} Contact - Displays the address and the email
 */
export default function Contact() {
  const { t } = useTranslation();

  return (
    <>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        style={{ height: "100vh" }}
      >
        <Grid item xs={10} md={6}>
          <Typography
            variant="h3"
            fontWeight={800}
            color={"green"}
            textAlign={"center"}
            gutterBottom
            sx={{ marginBottom: "30px" }}
          >
            {t("contact.header")}
          </Typography>
          <ContactContainer />
        </Grid>
      </Grid>
    </>
  );
}


/**
 * Contact Container Component
 * it's a helper function directly for the Contact component
 * 
 * It displays the Address along with the email below
 * if the email is pressed, it opens the mail app to write an email directly
 * 
 * @returns {JSX.Element} Contact Container - the body of the Contact component
 */
function ContactContainer() {
  return (
    <Box textAlign="center" sx={{ marginTop: "20px" }}>
      <Typography variant="h4" gutterBottom>
        RITA Consortium
      </Typography>
      <Typography variant="body1" gutterBottom>
        21111 Lakeshore Road Ste-Anne de Bellevue,
      </Typography>
      <Typography variant="body1" gutterBottom>
        Quebec H9X 3V9
      </Typography>
      <Typography variant="body1" gutterBottom>
        Email:{" "}
        <a href="mailto:fpd.consortiumrita@mcgill.ca">
          fpd.consortiumrita@mcgill.ca
        </a>
      </Typography>
    </Box>
  );
}
